export default {
  CASE_DETAILS: {
    OK: 'Ok',
    CASE_ID: 'Ügyazonosító:',
    COPIED: 'Másolva',
    COPIED_VALUE: 'Másolva: {{value}}',
    COPIED_LABELED: '{{label}} másolva: {{value}}',
    COPY: 'Másolás',
    DEBTOR_DATA: {
      TITLE: 'Adós adatai',
      NAME_LABEL: 'Adós neve',
      ADDRESS_LABEL: 'Adós címe',
      EMAIL_LABEL: 'Adós email címe',
      PHONE_LABEL: 'Adós telefonszáma',
    },
    LEGAL: {
      TITLE: 'Jogviszony igazolása',
      FILES_LABEL: 'Feltöltött fájlok',
      DESCRIPTION_LABEL: 'Szöveges indoklás',
    },
    BAILIFF_CONTACT: {
      TITLE: 'Végrehajtó elérhetősége',
    },
    CLAIMS: {
      TITLE: 'Követelések',
      TOTAL_LABEL: 'Teljes követelés',
      CAPITAL_CLAIMS: {
        TITLE: 'Tőkekövetelések:',
        INDEX: '{{index}}. követelés',
        DUE_DATE_LABEL: 'Fizetési határidő:',
        FILE_TITLE: 'Feltöltve:',
        TOTAL_LABEL: 'Összes tőkekövetelés',
      },
      OPTIONAL_CLAIMS: {
        TITLE: 'Járulékos követelések:',
        TOTAL_LABEL: 'Összes járulékos követelés',
      },
    },
    DOCUMENTS: {
      TITLE: 'Dokumentumok, azonosítók',
      PROFORMA_LABEL: 'Díjbekérő',
      INVOICE_LABEL: 'Számla',
      EXTERNAL_IDS_LABEL: 'Ügyszámok',
      PAYEE_ID_LABEL: 'Payee ügyazonosító',
      PAYEE_ID_TOOLTIP:
        'A Payee által generált ügyazonosító, kérjük erre hivatkozzon az ügyfélszolgálatunkon.',
      OFP_ID_TOOLTIP:
        'A közjegyző által a fizetési meghagyásos eljáráshoz rendelt ügyszám. Ezzel nincsen teendője, referenciaképpen mutatjuk.',
      DOWNLOAD: 'Letöltés',
      EXTERNAL_ID_TYPE: {
        ofp: 'Fizetési meghagyás ügyszám',
        enforcement: 'Végrehajtás ügyszám',
        bailiff: 'Végrehajtói jelvényszám',
      },
    },
    HISTORY: {
      TITLE: 'Ügytörténet',
      STARTED_AT: 'Indítva:',
    },
    ERROR_MESSAGES: {
      UNKNOWN_ERROR_WHILE_LOADING_DETAILS: 'Valami hiba történt a részletek betöltésekor!'
    }
  },
};